// extracted by mini-css-extract-plugin
export default {"custom-marker-icon":"MarkedMap_custom-marker-icon__Ad3E4"};